import React, { useContext, useEffect, useState, createContext } from "react";
import { db } from '../firebase';
import { doc, collection, setDoc, getDoc, getDocs, updateDoc } from "firebase/firestore";

import { useAuth } from './AuthContexts';
import { useUser } from './UserContexts';

// Creating User context to avoid multiple BD access
const GlobalContext = createContext();

export const useGlobal = () => {
    return useContext(GlobalContext);
}

export const GlobalProvider = ({ children }) => {

    const { currentUser } = useAuth();
    const { userInfo } = useUser();

    const [ loading, setLoading ] = useState(false);

    // State with all user information
    const [ weekRank, setWeekRank ] = useState([]);
    const [ generalRank, setGeneralRank ] = useState([]);

    // All functions first get info from BD and after changes context states
    const getRankData = async () => {
        try{
            let generalRankData = [];
            let weekRankData = [];
            const querySnapshot = await getDocs(collection(db, "users"));

            querySnapshot.forEach((doc) => {
                const currentUser = doc.data();
                generalRankData.push({
                    name: currentUser.name,
                    nTrains: currentUser.trainingDaysCount,
                    nDiets: currentUser.dietDaysCount,
                    nCardios: currentUser.cardioDaysCount,
                    pos: 0
                })
                const currentDate = new Date();
                const currentWeek = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));
                let dietCount = 0;
                let trainingCount = 0;
                let CardioCount = 0;
                const date = currentWeek;
                for(let i = 0; i < 7; i++){
                    const isoDate = String(date.getFullYear() + "-" + String(parseInt(date.getMonth() + 1)).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0'));
                    dietCount += (currentUser.dietDaysMap[isoDate] ? 1 : 0);
                    trainingCount += (currentUser.trainingDaysMap[isoDate] ? 1 : 0);
                    CardioCount += (currentUser.cardioDaysCount[isoDate] ? 1 : 0);
                    date.setDate(date.getDate() + 1);
                }

                weekRankData.push({
                    name: currentUser.name,
                    nTrains: trainingCount,
                    nDiets: dietCount,
                    nCardios: currentUser.CardioCount,
                    pos: 0
                })

            });
            generalRankData.sort((a, b) => {
                return (b.nTrains + b.nDiets  + b.nCardios) - (a.nTrains + a.nDiets + a.nCardios);
            })
            weekRankData.sort((a, b) => {
                return (b.nTrains + b.nDiets + b.nCardios) - (a.nTrains + a.nDiets + a.nCardios);
            })
            for(let i = 0; i < generalRankData.length; i++){
                generalRankData[i].pos = i + 1;
            }
            for(let i = 0; i < weekRankData.length; i++){
                weekRankData[i].pos = i + 1;
            }
            setGeneralRank(generalRankData);
            setWeekRank(weekRankData);

            console.log("Carreguei de novo")
            // console.log(generalRankData);
            // console.log(weekRankData);
            
        } catch(e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getRankData();
    }, [currentUser, userInfo]);
    
    const value = {
        weekRank,
        generalRank
    }
    
    return (
        <GlobalContext.Provider value={value}>
            { !loading && children }
        </GlobalContext.Provider>
    )
}
